import React from 'react'
import { useEffect, useState } from "react";

import axios from "axios";
import { useDispatch } from "react-redux";
import { toAbsoluteUrl } from "../../../Utils/_helpers";
import OpcSelect from "../../components/select/src";
import { API_ENDPOINTS } from "../../util/constants";

const UserPhoto = ({ user }) => {
  return (
    <>
      {user.img && user.img !== "" && (
        <span className="">
          <img alt="" src={user.img} className="t-dp" />
        </span>
      )}
      {(!user.img || user.img === "") && (
        <span className="t-dp-initial symbol-label font-size-h5 font-weight-bold">
          {user.name[0].toLocaleUpperCase()}
        </span>
      )}
    </>
  );
};

const getTelIcon = (agent) => {
  if (agent) {
    return <UserPhoto user={{ name: agent.first_name }} />;
  }
  return (
    <span className="">
      <img
        alt=""
        className="t-dp"
        src={toAbsoluteUrl("/media/sr/icons/callid.svg")}
      />
    </span>
  );
};

export const CliInput = (props) => {
  const [selected, setSelected] = useState("");
  const onSelect = (code) => {
    setSelected(code);
    props.onEvent({ type: "c2c_form::set", key: "caller_id", value: code });
  };
  const dispatch = useDispatch();

  const showSelectedLabel = true;
  const showSecondarySelectedLabel = true;
  const showOptionLabel = true;
  const showSecondaryOptionLabel = true;
  const searchable = true;

  const [customLabels, setCustomLabels] = useState({});

  const [valueCodes, setValueCodes] = useState([]);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const api = async () => {
      const url = API_ENDPOINTS.getCallIDNumbers;
      const is_promotional = props.is_promotional ? 1 : 0;
      try {
        const params = { sr_number: props.sr_number, is_promotional: is_promotional };
        const response = await axios.get(url, { params: params });
        if (
          response &&
          response.data &&
          response.data.callerid &&
          response.data.callerid.length > 0
        ) {
          const customLabels1 = {};
          const values_codes = [];
          let val = "";
          // if (response.data.srnumber[0] !== props.sr_number) {
            let payload = {
              ticker_initial_srnumber: response.data.srnumber[0],
            };
            if (!props.selectedCallerId) {

              if (response.data.previousCaller) {
                val = response.data.previousCaller
              } else if (response.data.defaultCaller) {
                val = response.data.defaultCaller
              } else {
                if (response.data.callerid.length > 0) 
                  val = response.data.callerid[0]
              }

              payload = {
                ...payload,
                ticker_initial_callerid: val,
              };
            }
            dispatch({
              type: "onSetTickerState",
              payload: payload,
            });
          // }
          response.data.callerid.map((number, i) => {
            let option = {
              icon: getTelIcon(),
              data: number,
              primary: number,
              secondary: "",
            };
            let key = number;
            customLabels1[key] = option;
            values_codes.push(key);
          });

          if (values_codes.length === 0) {
            setVisible(false);
          } else {
            setVisible(true);
          }
          setValueCodes(values_codes);
          setCustomLabels(customLabels1);
          if (!props.selectedCallerId) {
            setSelected(val);
            onSelect(val);
          }
        } else {
          setVisible(false);
        }
      } catch (error) {
        setVisible(false);
        return error.response;
      }
    };

    if (props.sr_number && props.sr_number !== "") {
      api();
    }
    return () => {
      onSelect('')
    };
  }, [props.sr_number, props.is_promotional]);

  useEffect(() => {
    if (props.selectedCallerId && customLabels) {
      onSelect(props.selectedCallerId);
      dispatch({
        type: "onSetTickerState",
        payload: { ticker_initial_callerid: "" },
      });
    }
  }, [customLabels]);

  return (
    <div className="row tel-select">
      <div className="col-12 flex-d">
        <div
          className="demo-wrapper"
          style={{ display: visible ? "block" : "none" }}
        >
          <OpcSelect
            type="callid"
            placeholder="Caller ID"
            searchPlaceholder="Search Caller ID"
            selected={selected}
            onSelect={onSelect}
            showSelectedLabel={showSelectedLabel}
            showSecondarySelectedLabel={showSecondarySelectedLabel}
            showOptionLabel={showOptionLabel}
            showSecondaryOptionLabel={showSecondaryOptionLabel}
            customLabels={customLabels}
            countries={valueCodes}
            searchable={searchable}
            placeholderIcon={getTelIcon()}
            optionItemIcon={getTelIcon()}
            selectButtonClassName={"opselect-form-field-outline"}
          />
        </div>
      </div>
    </div>
  );
};
